import { FilterData } from "../queries/getSolutionFilterData";
import { ContentBlock } from "./contentBlock";
import { Solution } from "./solutions";

export type SolutionGrid = {
    _type: 'solutionGrid';
    _key: string;
    title: string;
    filterLabel: string;
    serviceLabel: string;
    industryLabel: string;
    emptyStateMessage: string;
    emptyShowcaseSolutions: Array<Solution>;
    solutions?: Array<Solution>;
    filterData?: FilterData;
}

export const isSolutionGrid = (solution: ContentBlock): solution is SolutionGrid => {
    return solution._type === 'solutionGrid';
}